// removed by extract-text-webpack-plugin
module.exports = {"travelersWrap":"qempo_Testimonials_travelersWrap-gCMAL3m","testimonialWrap":"qempo_Testimonials_testimonialWrap-3H6hyZg"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/testimonials/components/Testimonials.scss
// module id = 1418
// module chunks = 0